import { render, staticRenderFns } from "./DepartmentConfirmDialog.vue?vue&type=template&id=505c123c&scoped=true"
import script from "./DepartmentConfirmDialog.vue?vue&type=script&lang=js"
export * from "./DepartmentConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c123c",
  null
  
)

export default component.exports